module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-history"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v(_vm._s(_vm.$t('User List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('User History')))])])]), (_vm.user != null && !_vm.loading && _vm.callbackflg && _vm.stepUpEnd) ? _c('div', [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-6 text-center"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [(!_vm.isBrowsIncluding) ? _c('p', [_c('img', {
    staticClass: "img-rounded",
    staticStyle: {
      "width": "auto",
      "max-height": "200px"
    },
    attrs: {
      "src": _vm.user.attributes['avartar-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    },
    on: {
      "click": function($event) {
        _vm.onClickImageModalShow(_vm.user)
      }
    }
  })]) : _vm._e(), _c('h4', [_vm._v(_vm._s(_vm.user.attributes['user-name']) + "　" + _vm._s(_vm.user.attributes['user-firstname'])), _c('br'), _vm._v("（" + _vm._s(_vm.user.attributes['user-name-furigana']) + " " + _vm._s(_vm.user.attributes['user-firstname-furigana']) + "）")]), (_vm.isSystemManagement || _vm.isAppIncluding || (_vm.isAppNotIncluded && _vm.localShopId == _vm.user.attributes['shop-id'])) ? _c('p', {
    staticClass: "profile"
  }, [_vm._v("性別 : " + _vm._s(_vm.user.attributes['sex'])), _c('br'), _vm._v("生年月日 : " + _vm._s(_vm.user.attributes['user-birthday-format'])), _c('br'), _vm._v("年齢 : " + _vm._s(_vm.user.attributes['age']) + " 歳")]) : _c('p', {
    staticClass: "profile"
  }, [_vm._v("性別 : " + _vm._s(_vm.user.attributes['sex'])), _c('br'), _vm._v("誕生日 : " + _vm._s(_vm.user.attributes['user-birthday-format'].slice(5)))])])]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(!_vm.isBrowsIncluding) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v("ＩＤ")]) : _vm._e(), (!_vm.isBrowsIncluding) ? _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['login-id']))])]) : _vm._e(), (!_vm.isBrowsIncluding) ? _c('hr') : _vm._e(), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("所属店舗")]), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['shop-name']))])]), _c('hr'), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("役職")]), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['user-type-name']))])]), _c('hr'), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("入社日")]), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['user-joinday-format']))])]), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("入社経緯")]), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['join-class']))])]), (_vm.afterOver) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v("離職日")]) : _vm._e(), (_vm.afterOver) ? _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['user-overday-format']))])]) : _vm._e(), (_vm.beforeOver) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v("離職予約日")]) : _vm._e(), (_vm.beforeOver) ? _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['user-overday-format']))])]) : _vm._e()])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("役職異動履歴")]), _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(0), _vm._l((_vm.usertypeHistories), function(usertypeHistory) {
    return _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(usertypeHistory.attributes['user-type-name-before']))]), _c('td', [_vm._v(_vm._s(usertypeHistory.attributes['user-type-name-after']))]), _c('td', [_vm._v(_vm._s(usertypeHistory.attributes['change-day-format']))])])])
  })], 2)]), ((_vm.usertypeHistories != null && _vm.usertypeHistories.length > 0) && ((_vm.isSystemManagement || ((_vm.isAppIncluding || _vm.isAppNotIncluded) && _vm.localShopId == _vm.user.attributes['shop-id'])) && !_vm.afterOver)) ? _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.usertypeHistoryCancel(_vm.user.id)
      }
    }
  }, [_vm._v("直近の役職異動をキャンセル")])]) : _vm._e()]), _c('div', {
    staticClass: "col-sm-1"
  }), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("店舗異動履歴")]), _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(1), _vm._l((_vm.shopHistories), function(shopHistory) {
    return _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(shopHistory.attributes['shop-name-before']))]), _c('td', [_vm._v(_vm._s(shopHistory.attributes['shop-name-after']))]), _c('td', [_vm._v(_vm._s(shopHistory.attributes['change-day-format']))])])])
  })], 2)]), ((_vm.shopHistories != null && _vm.shopHistories.length > 0) && ((_vm.isSystemManagement || ((_vm.isAppIncluding || _vm.isAppNotIncluded) && _vm.localShopId == _vm.user.attributes['shop-id'])) && !_vm.afterOver)) ? _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.shopHistoryCancel(_vm.user.id)
      }
    }
  }, [_vm._v("直近の店舗異動をキャンセル")])]) : _vm._e()]), _c('div', {
    staticClass: "col-sm-1"
  })]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-6 text-left"
  }, [((_vm.isSystemManagement || ((_vm.isAppIncluding || _vm.isAppNotIncluded) && _vm.localShopId == _vm.user.attributes['shop-id'])) && !_vm.afterOver) ? _c('a', {
    staticClass: "btn btn-info",
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.goUsertypeHistoryEdit(_vm.user.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('span', [_vm._v("役職異動")])]) : _vm._e(), ((_vm.isSystemManagement || ((_vm.isAppIncluding || _vm.isAppNotIncluded) && _vm.localShopId == _vm.user.attributes['shop-id'])) && !_vm.afterOver) ? _c('a', {
    staticClass: "btn btn-info",
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.goShopHistoryEdit(_vm.user.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('span', [_vm._v("店舗異動")])]) : _vm._e()]), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.goBackList
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _c('span', [_vm._v("戻る")])])])])]) : _vm._e(), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "imageModalButton",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#imageModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "imageModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modalcenter"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _c('div', {
    staticClass: "modal-img_footer text-center"
  }, [_c('p', {
    attrs: {
      "id": "imageModalText"
    }
  }), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', [_vm._v("役職異動前")]), _c('th', [_vm._v("役職異動後")]), _c('th', [_vm._v("異動日付")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', [_vm._v("店舗異動前")]), _c('th', [_vm._v("店舗異動後")]), _c('th', [_vm._v("異動日付")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "id": "imageModalImg",
      "src": "",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dcdc9f3a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/user-history.pug
// module id = 887
// module chunks = 1